// BuyChallengeFooter.tsx
import React from 'react';
import classes from './_buyChallenge.module.scss';

interface BuyChallengeFooterProps {
  t: any;
}

const BuyChallengeFooter: React.FC<BuyChallengeFooterProps> = ({ t }) => {
  return (
    <footer className={classes.mainFooter}>
      <div>
        <p>{t('footer.paragraphOne')}</p>
        <br />
        <p>{t('footer.paragraphTwo')}</p>
        <br />
        <p>{t('footer.paragraphThree')}</p>
        <br />
        <p>{t('footer.paragraphFour')}</p>
      </div>
      <hr />
      <p className={classes.copyright}>{t('footer.copyrightText')}</p>
    </footer>
  );
};

export default BuyChallengeFooter;
